export const handleError = (error: any) => {
  console.error('An error occurred:', error);
  // Ajoutez ici une gestion des erreurs plus sophistiquée si nécessaire
};
